import { get } from "./Api";

export function SearchMemberProfile({ lineId }) {
  return get({ url: `/api/v1/haire/member/search/proflie/${lineId}`});
}